export default function Machines_B_8 (number = 1) {
  return {
    name: '行星内物流运输站',
    icon: '/static/img/machines/b8.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_8.js